export const ADMIN_LOGIN_PAGE = "/admin/login";
export const ADMIN_HOME_PAGE = "/admin";
export const ADMIN_SCHEDULE_PAGE = "/admin/schedule";
export const ADMIN_ANNOUNCEMENTS_PAGE = "/admin/announcements";
export const ADMIN_PARTICIPANTS_PAGE = "/admin/participants";
export const ADMIN_TASKS_PAGE = "/admin/task-library";
export const ADMIN_BADGES_PAGE = "/admin/badge-library";
export const ADMIN_REPORTS_PAGE = "/admin/reports";

export const PARTICIPANTS_LOGIN_PAGE = "/login";
export const PARTICIPANTS_HOME_PAGE = "/";
export const PARTICIPANTS_SCHEDULE_PAGE = "/schedule";
export const PARTICIPANTS_ANNOUNCEMENTS_PAGE = "/announcements";
export const PARTICIPANTS_TASKS_PAGE = "/tasks";
export const PARTICIPANTS_PROGRESS_PAGE = "/progress";
